export const form06Columns =
[
  {
    headerName: 'FlagDetail',
    field: 'FlagDetail',
  },
  {
    headerName: 'SandiKC',
    field: 'SandiKC',
  },
  {
    headerName: 'NoNasabah',
    field: 'NoNasabah',
    filter: true,
  },
  {
    headerName: 'NamaNasabah',
    field: 'NamaNasabah',
  },
  {
    headerName: 'NIK',
    field: 'NIK',
  },
  {
    headerName: 'NoKelompokNasabah',
    field: 'NoKelompokNasabah',
  },
  {
    headerName: 'GolonganNasabah',
    field: 'GolonganNasabah',
  },
  {
    headerName: 'HubunganDenganBank',
    field: 'HubunganDenganBank',
  },
  {
    headerName: 'KategoriUsaha',
    field: 'KategoriUsaha',
  },
  {
    headerName: 'NoRek',
    field: 'NoRek',
  },
  {
    headerName: 'TglMulai',
    field: 'TglMulai',
  },
  {
    headerName: 'TglJatuhTempo',
    field: 'TglJatuhTempo',
  },
  {
    headerName: 'SumberDana',
    field: 'SumberDana',
  },
  {
    headerName: 'Porsi',
    field: 'Porsi',
  },
  {
    headerName: 'LokasiProyek',
    field: 'LokasiProyek',
  },
  {
    headerName: 'JenisPiutang',
    field: 'JenisPiutang',
  },
  {
    headerName: 'SifatPiutang',
    field: 'SifatPiutang',
  },
  {
    headerName: 'StatusPiutang',
    field: 'StatusPiutang',
  },
  {
    headerName: 'JenisPenggunaan',
    field: 'JenisPenggunaan',
  },
  {
    headerName: 'SektorEkonomi',
    field: 'SektorEkonomi',
  },
  {
    headerName: 'NilaiKontrak',
    field: 'NilaiKontrak',
  },
  {
    headerName: 'PeriodePembayaranAngsuran',
    field: 'PeriodePembayaranAngsuran',
  },
  {
    headerName: 'PersentaseImbalanAwalKontrak',
    field: 'PersentaseImbalanAwalKontrak',
  },
  {
    headerName: 'PersentaseImbalanBulanLaporan',
    field: 'PersentaseImbalanBulanLaporan',
  },
  {
    headerName: 'Kualitas',
    field: 'Kualitas',
  },
  {
    headerName: 'StatusBMPD',
    field: 'StatusBMPD',
  },
  {
    headerName: 'Nominal',
    field: 'Nominal',
  },
  {
    headerName: 'BiayaAdminBlmDiamortisasi',
    field: 'BiayaAdminBlmDiamortisasi',
  },
  {
    headerName: 'SaldoHargaPokok',
    field: 'SaldoHargaPokok',
  },
  {
    headerName: 'SaldoMarginDitangguhkan',
    field: 'SaldoMarginDitangguhkan',
  },
  {
    headerName: 'Jumlah',
    field: 'Jumlah',
  },
  {
    headerName: 'TunggakanHari',
    field: 'TunggakanHari',
  },
  {
    headerName: 'TunggakanPokok',
    field: 'TunggakanPokok',
  },
  {
    headerName: 'TunggakanMargin',
    field: 'TunggakanMargin',
  },
  {
    headerName: 'ImbalanYangAkanDiterima',
    field: 'ImbalanYangAkanDiterima',
  },
  {
    headerName: 'JenisAgunan',
    field: 'JenisAgunan',
  },
  {
    headerName: 'JenisPengikatan',
    field: 'JenisPengikatan',
  },
  {
    headerName: 'NoAgunan',
    field: 'NoAgunan',
  },
  {
    headerName: 'Karat',
    field: 'Karat',
  },
  {
    headerName: 'Berat',
    field: 'Berat',
  },
  {
    headerName: 'LokasiLatitude',
    field: 'LokasiLatitude',
  },
  {
    headerName: 'LokasiLongitude',
    field: 'LokasiLongitude',
  },
  {
    headerName: 'GolonganPenjamin',
    field: 'GolonganPenjamin',
  },
  {
    headerName: 'TglPenilaianTerakhir',
    field: 'TglPenilaianTerakhir',
  },
  {
    headerName: 'NilaiAgunan',
    field: 'NilaiAgunan',
  },
  {
    headerName: 'NilaiYangDapatDiperhitungkan',
    field: 'NilaiYangDapatDiperhitungkan',
  },
  {
    headerName: 'BagianDijamin',
    field: 'BagianDijamin',
  },
  {
    headerName: 'CKPN',
    field: 'PPAP',
  },
  {
    headerName: 'Jenis_CKPN',
    field: 'Jenis_CKPN',
  },
  {
    headerName: 'tgl_mulai_macet',
    field: 'tgl_mulai_macet',
  },
  {
    headerName: 'pembiayaan_program_pemerintah',
    field: 'pembiayaan_program_pemerintah',
  },
  {
    headerName: 'sektor_kredit_usaha_rakyat',
    field: 'sektor_kredit_usaha_rakyat',
  },
  {
    headerName: 'tgl_akad_awal',
    field: 'tgl_akad_awal',
  },
  {
    headerName: 'tgl_akad_akhir',
    field: 'tgl_akad_akhir',
  },
  {
    headerName: 'sandi_fintech_p2pl',
    field: 'sandi_fintech_p2pl',
  },
]
